import { primeOrdersCache, clearOrdersCache } from './orders'
import { primeBillsCache, clearBillsCache } from './bills'
import { primeTablesCache, clearTablesCache } from './tables'
import { primeCategoriesCache, clearCategoriesCache } from './categories'
import { primeStationsCache, clearStationsCache } from './stations'
import { primeMenuItemsCache, clearMenuItemsCache } from './menuItems'
import { primeSettingsCache, clearSettingsCache } from './settings'

/** Prime all Firestore caches. Call once when app loads with Firestore enabled. */
export async function primeAllCaches(): Promise<void> {
  await primeCategoriesCache()
  await Promise.all([
    primeOrdersCache(),
    primeBillsCache(),
    primeTablesCache(),
    primeStationsCache(),
    primeMenuItemsCache(),
    primeSettingsCache(),
  ])
}

/** Clear all in-memory Firestore caches. Call on logout so the next user does not see previous account/place data. */
export function clearAllCaches(): void {
  clearOrdersCache()
  clearBillsCache()
  clearTablesCache()
  clearCategoriesCache()
  clearStationsCache()
  clearMenuItemsCache()
  clearSettingsCache()
}
